import React, { useEffect, useState, useContext } from 'react'
import Card from '../../../Components/Card/Card'
import { setTitlePage } from '../../../Services/Config/ConfigService'
import { Button } from 'primereact/button'
import { getSesiones } from '../../../API/IT/Sesiones/SesionesRequests'
import AgGrid from '../../../Components/Tables/AgGrid/AgGrid'
import { getLabel } from "../../../Services/Language/LanguageService";
import { baseLang } from "../../../Lang/BaseLang";
import { ConfigContext } from "../../../Context/ConfigContext/ConfigContext";
import { AuthContext } from "../../../Context/AuthContext/AuthContext";

const SesionesScreen = () => {
  const { config } = useContext(ConfigContext);
  const { userAuth } = useContext(AuthContext);

  const [Sesiones, setSesiones] = useState([]);
  const [loading, setLoading] = useState(false);

  const getInfo = async () => {
    setLoading(true);
     const d = await getSesiones();
    //  console.log(d);
     setSesiones(d);
     setLoading(false);
  }

  const columns = [
    {
      header: 'ID',
      headerEn:'ID',
      field: 'IdSession',
      className: 'Xsmall',
      hidden: userAuth.IdRol === 1
  },
    {
        header: 'ID Usuario',
        headerEn:'ID User',
        field: 'IdUser',
        className: 'Xsmall',
        hidden: userAuth.IdRol === 1
    },
    {
      header: 'Tipo',
      headerEn:'Type',
      field: 'Type',
      className: 'small',
  },
    {
        header: 'Usuario',
        headerEn:'User',
        field: 'Usuario',
        className: 'small',
    },
    {
        header: 'Nombre Usuario',
        headerEn:'User Name',
        field: 'UserName',
    },
    {
      header: 'IdRol',
      headerEn:'IdRol',
      field: 'IdRol',
      className: 'Xsmall',
      hidden: userAuth.IdRol === 1
    },
    {
      header: 'Rol',
      headerEn:'Rol',
      field: 'Rol',
    },
    {
        header: 'Fecha Creado',
        headerEn:'Created Date',
        field: 'Creado',
        Format: 'DateTime',
        flex:1
    },
    {
        header: 'Fecha Vencimiento',
        headerEn:'Expiration Date',
        field: 'Vencimiento',
        Format: 'DateTime',
        flex:1
    },
    {
        header: 'IP',
        field: 'IP',
    },
    {
        header:'Dispositivo',
        headerEn: 'Device',
        field: 'Device',
    },
    
  ];

  const table = {
    Columns: columns,
    Data: Sesiones,
    loading: loading,
  };

  useEffect(() => {
    setTitlePage(getLabel(baseLang, "sesion", config.language));
    getInfo();
  }, [])

  return (
    <div>
      <Card
        titulo={<div className='botones'>
          <h3>{getLabel(baseLang, "sesion", config.language)}</h3>
          <Button  icon='pi pi-refresh' onClick={getInfo}/>
        </div>}
        contenido={<div className='p-4' style={{ height: '90vh' }}>
          <AgGrid table={table} />
        </div>}
      />
    </div>
  )
}

export default SesionesScreen